

export default {
  name: `IconCheck`,
}
